import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PaymentBankAccount } from '../../../../../models/entities/payment-bank-account';
import { UnifiedBankAccount } from '../../../../../models/entities/unified-bank-account';
import { BankAccountsService } from '../../../../../services/financial-accounts/bank-accounts.service';
import { GrowlerService } from '../../../../../services/growler.service';
import { PaymentMethodsService } from '../../../../../services/financial-accounts/payment-methods.service';
import { GenericDialogResult } from '../../generic-mat-dialog/generic-dialog-result';

export interface DeleteBankAccountDialogInput
{
    account: PaymentBankAccount | UnifiedBankAccount;
    replacementCandidates?: UnifiedBankAccount[];
}

@Component({
    selector: 'app-delete-bank-account-dialog',
    templateUrl: './delete-bank-account-dialog.component.html',
    styleUrls: ['./delete-bank-account-dialog.component.scss'],
})
export class DeleteBankAccountDialogComponent implements OnInit
{

    public isUserAccount: boolean = false;
    public replacementDepositAccount: UnifiedBankAccount = null;
    public deleteInFlight: boolean = false;

    constructor(
            private _dialogRef: MatDialogRef<DeleteBankAccountDialogComponent>,
            private _bankAccountsService: BankAccountsService,
            private _growlerService: GrowlerService,
            private _paymentMethodsService: PaymentMethodsService,
            @Inject(MAT_DIALOG_DATA) public data: DeleteBankAccountDialogInput,
    ) {
    }

    ngOnInit() {
        if (this.data.account instanceof PaymentBankAccount) {
            this.isUserAccount = true;
        }
    }

    closeDialog() {
        this._dialogRef.close(<GenericDialogResult>{success: false});
    }

    deleteAccount() {
        this.deleteInFlight = true;
        if (this.data.account instanceof PaymentBankAccount) {
            this._paymentMethodsService
                    .removeBankAccountFromUser(this.data.account.ownerId, this.data.account.id)
                    .subscribe(
                            () => {
                                this._growlerService.success(
                                        'Success',
                                        'Your bank account has been deleted.',
                                );
                                this.deleteInFlight = true;
                                this._dialogRef.close(<GenericDialogResult>{
                                    success: true,
                                });
                            },
                            () => {
                                this.deleteInFlight = true;
                                this._growlerService.error(
                                        'Oops...',
                                        'There was an error deleting your bank account.',
                                );
                            },
                    );
        } else {
            const replacementId: number = this.replacementDepositAccount && this.replacementDepositAccount.id
                    ? this.replacementDepositAccount.id
                    : null;

            this._bankAccountsService
                    .removeBankAccountFromOrg(
                            this.data.account.organizationId,
                            this.data.account.id,
                            replacementId,
                    )
                    .subscribe(
                            () => {
                                this.deleteInFlight = true;
                                this._growlerService.success(
                                        'Success',
                                        'Your bank account has been deleted.',
                                );
                                this._dialogRef.close(<GenericDialogResult>{
                                    success: true,
                                });
                            },
                            () => {
                                this.deleteInFlight = true;
                                this._growlerService.error('Oops!', 'An unexpected server error occurred. Please try again.');
                            },
                    );
        }
    }
}
